import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import { generateDataTestidAttribute } from '../../../services/testid-service';

import style from './modal-footer.module.css';

/**
 * @deprecated Use `Modal` from `@mantine/core` + `ModalContent`/`ModalFooter` from `@shipstation/client-common` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 */
export const ModalFooter = ({ className = '', children }) => {
  return (
    <div {...generateDataTestidAttribute('modal-footer')} className={classNames(style['modal-footer'], className)}>
      {children}
    </div>
  );
};

ModalFooter.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};
